import { ApplicationType } from '@/types/bankAccounts';

type GenerateBankAccountDisplayNameProps = {
  applicationType: ApplicationType;
  businessName?: string;
  fullName: string;
  email: string;
  totalOwners: number;
};
export function generateBankAccountDisplayName({
  applicationType,
  businessName = '',
  fullName,
  email,
  totalOwners,
}: GenerateBankAccountDisplayNameProps) {
  return `${applicationType === ApplicationType.BUSINESS ? `${businessName}: ` : ''}${fullName} (${email})${totalOwners > 1 ? ' +1' : ''}`;
}
